import { BodypartType } from "@growth-machine-llc/stridist-api-client";
import { useToastAlert } from "../../app/ToastAlert/ToastAlertProvider";
import { filterOutNoneOption } from "../filters/filterUtils";
import { EMPTY_BODYPARTS_MESSAGE } from "../../../constants";

interface IValidateBodypartsProps {
  message?: string;
  showToastAlertFlag?: boolean;
}

export const useValidateBodyparts = ({
  message = EMPTY_BODYPARTS_MESSAGE,
  showToastAlertFlag = true,
}: IValidateBodypartsProps = {}) => {
  const { showToastAlert } = useToastAlert();
  const validateBodyparts = (bodyparts: BodypartType[]) => {
    const filtered = filterOutNoneOption(bodyparts);
    if (filtered.length === 0) {
      if (showToastAlertFlag) {
        showToastAlert("info", { message: message });
      }
      return false;
    }
    return true;
  };

  return validateBodyparts;
};
